import { groupBy } from 'lodash';
import { useEffect, useState } from 'react';
import type { EpisodeCategory } from '../../../../common/enums';
import type { IServiceGroupSetting } from '../../interfaces/serviceGroupSetting';
import type { IServiceGroupSettingsByCategory } from '../../interfaces/serviceGroupSettingsByCategory';
import { isActiveOnDate } from '../../../../common/utils/isActiveOnDate';
import { UrlBuilder } from '../../../../common/utils/urlBuilder';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { GroupEpisodeCategoriesView } from './GroupEpisodeCategoriesView';

export interface IGroupDetailsProps {
    groupId: string;
}

export function GroupCarePathsOverview({ groupId }: IGroupDetailsProps) {
    const abortableFetch = useAbortableFetch();
    const [groupCarePaths, setGroupCarePaths] = useState<IServiceGroupSettingsByCategory[]>([]);

    useEffect(() => {
        loadCarePaths();
    }, [groupId]);

    return (
        <>
            <GroupEpisodeCategoriesView
                groupCarePaths={[...groupCarePaths]}
                groupId={groupId}
            />
        </>
    );

    async function loadCarePaths() {
        const urlBuilder = new UrlBuilder('/api/serviceGroupSettings');
        urlBuilder.add('groupId', groupId);
        urlBuilder.add('includeServiceGroups', 'true');
        urlBuilder.add('isActive', true);

        const url = urlBuilder.build();
        const result = await abortableFetch.fetchJson(url, 'GET');
        const groupedServiceGroupSettings = groupServiceGroupSettingsByCategory(result.json.items);

        setGroupCarePaths([...groupedServiceGroupSettings]);
    }

    function groupServiceGroupSettingsByCategory(serviceGroupSettings: IServiceGroupSetting[]) {
        const settingsByCategory = groupBy(serviceGroupSettings, (settings) => settings.service.episodeCategory.name);

        return Object.keys(settingsByCategory).map((episodeCategory) => ({
            episodeCategory: episodeCategory as EpisodeCategory,
            activeSettings: settingsByCategory[episodeCategory].filter((setting) =>
                isActiveOnDate(setting, new Date())
            ),
            inactiveSettings: settingsByCategory[episodeCategory].filter(
                (setting) => !isActiveOnDate(setting, new Date())
            ),
        }));
    }
}
